
import React, { useState, useEffect } from "react";
import { Card, Col, Row, Form, Button, Container } from "react-bootstrap";
import CatEmpleados from "../Services/Catalogos/CatEmpleados";
import DTOEmpleadoVac from "../Componest/Catalogos/CatEmpleados/DTO/DTOEmpleadoVac";

export default function UsuarioDashboard() {
  const [userData, setUserData] = useState<DTOEmpleadoVac[]>([]);
  const [photo, setPhoto] = useState<File | null>(null);
  const [signature, setSignature] = useState<File | null>(null);
  const [photoUrl, setPhotoUrl] = useState<string>("");
  const [signatureUrl, setSignatureUrl] = useState<string>("");

  
  const loadUsers = () => {
    const userIdString = localStorage.getItem("UserId");
    if (!userIdString) return;

    const userId = Number(JSON.parse(userIdString));
    if (isNaN(userId) || userId <= 0) return;

    CatEmpleados.GetIdEmpleado(userId)
      .then((response) => {
        if (response.data.length > 0) {
          setUserData(response.data);
          const user = response.data[0];

          CatEmpleados.GetFotoFirma(user.numEmpleado, 'foto')
            .then((url) => setPhotoUrl(url))
            .catch(console.error);
          CatEmpleados.GetFotoFirma(user.numEmpleado, 'firma')
            .then((url) => setSignatureUrl(url))
            .catch(console.error);
        }
      })
      .catch((e) => console.error(e));
  };

  const handlePhotoUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    setPhoto(file || null);
    if (file) setPhotoUrl(URL.createObjectURL(file));
  };

  const handleSignatureUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    setSignature(file || null);
    if (file) setSignatureUrl(URL.createObjectURL(file));
  };

  const saveFiles = () => {
    if (!userData[0]?.numEmpleado) return;
    CatEmpleados.SaveFotoFirma(userData[0].numEmpleado, photo, signature)
      .then(() => {
        alert("¡Datos actualizados con éxito!");
        loadUsers();
      })
      .catch(() => alert("Error al guardar."));
  };

  useEffect(() => {
    loadUsers();
  }, []);


  const styles = `
    /* Contenedor principal: Transparente para respetar tu fondo blanco */
    .dashboard-container {
      background: transparent; 
      padding-top: 30px;
      padding-bottom: 50px;
      font-family: 'Segoe UI', sans-serif;
    }

    /* La Tarjeta Principal */
    .profile-card {
      background: #ffffff;
      border: 1px solid #f0f2f5; /* Borde muy sutil */
      border-radius: 16px; /* Bordes redondeados como tu tarjeta de "Buenas tardes" */
      /* Sombra suave para que flote sobre el blanco */
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06); 
      overflow: hidden;
    }

    .card-header-custom {
      background: #fff;
      border-bottom: 2px solid #f0f2f5;
      padding: 25px;
      text-align: center;
    }
    
    .header-title {
      color: #2c3e50;
      font-weight: 700;
      font-size: 1.2rem;
      text-transform: uppercase;
      letter-spacing: 1px;
      margin: 0;
    }

    /* Inputs Modernos (Gris muy claro) */
    .input-modern {
      background: #f8f9fa !important;
      border: 1px solid #e9ecef !important;
      color: #495057 !important;
      border-radius: 8px;
      padding: 12px;
      transition: all 0.2s;
      font-weight: 500;
    }
    .input-modern:focus {
      background: #fff !important;
      border-color: #4a90e2 !important; /* Azul similar a tu navbar */
      box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1) !important;
    }
    .input-modern[readonly] {
      background: #f1f3f5 !important; /* Diferencia sutil para readonly */
      color: #6c757d !important;
    }

    /* Etiquetas */
    .label-modern {
      color: #6c757d;
      font-size: 0.75rem;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      margin-bottom: 6px;
      display: block;
    }

    /* Imagen de perfil */
    .profile-pic-wrapper {
      width: 160px;
      height: 160px;
      margin: 0 auto 20px;
      border-radius: 50%;
      padding: 4px;
      /* Borde degradado azul para combinar con RHMEX */
      background: linear-gradient(135deg, #4a90e2 0%, #0056b3 100%);
    }
    .profile-pic {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
      border: 4px solid #fff; /* Anillo blanco interno */
      background-color: #eee;
    }

    /* Botones de Subir (Upload) */
    .upload-btn {
      display: inline-block;
      padding: 8px 20px;
      background: #eef2f7;
      color: #4a90e2;
      border-radius: 50px;
      font-weight: 600;
      font-size: 0.85rem;
      cursor: pointer;
      transition: all 0.2s;
      border: 1px solid transparent;
      width: 100%;
      text-align: center;
    }
    .upload-btn:hover {
      background: #4a90e2;
      color: #fff;
    }
    input[type="file"] { display: none; }

    /* Área de firma */
    .signature-box {
      background: #fcfcfc;
      border: 2px dashed #dee2e6;
      border-radius: 8px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 80px;
      margin-bottom: 10px;
    }

    /* Botón Principal */
    .btn-save {
      background: #4a90e2; /* Azul RHMEX */
      border: none;
      padding: 12px 30px;
      border-radius: 8px;
      font-weight: 600;
      letter-spacing: 0.5px;
      width: 100%;
      margin-top: 25px;
      box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
      transition: transform 0.2s;
    }
    .btn-save:hover {
      background: #357abd;
      transform: translateY(-2px);
    }
  `;

  return (
    <div className="dashboard-container">
      <style>{styles}</style>
      <Container>
        <Row className="justify-content-center">
          <Col lg={9}>
            <div className="profile-card">
              <div className="card-header-custom">
                <h5 className="header-title">Mi Información Personal</h5>
              </div>
              
              <div className="p-4 p-md-5">
                {userData.length > 0 ? (
                  <Row>
                    {/* COLUMNA IZQUIERDA: Visual (Foto/Firma) */}
                    <Col md={4} className="text-center mb-4 mb-md-0 border-end-md">
                      
                      {/* Foto */}
                      <div className="mb-4">
                        <div className="profile-pic-wrapper">
                          <img
                            src={photoUrl || "https://via.placeholder.com/160?text=Foto"} 
                            alt="Perfil"
                            className="profile-pic"
                          />
                        </div>
                        <label className="upload-btn">
                          <i className="bi bi-camera"></i> Cambiar Foto
                          <input type="file" accept="image/*" onChange={handlePhotoUpload} />
                        </label>
                      </div>

                      {/* Firma */}
                      <div className="mt-4">
                        <span className="label-modern text-center">Firma Digital</span>
                        <div className="signature-box">
                          <img
                            src={signatureUrl || "https://via.placeholder.com/150x50?text=Sin+Firma"}
                            alt="Firma"
                            style={{ maxWidth: '100%', maxHeight: '60px', opacity: signatureUrl ? 1 : 0.4 }}
                          />
                        </div>
                        <label className="upload-btn">
                          <i className="bi bi-pencil"></i> Subir Firma
                          <input type="file" accept="image/*" onChange={handleSignatureUpload} />
                        </label>
                      </div>
                    </Col>

                    {/* COLUMNA DERECHA: Formulario */}
                    <Col md={8}>
                      <div className="ps-md-4">
                        <Row>
                          <Col xs={12} md={4}>
                            <Form.Group className="mb-3">
                              <span className="label-modern">ID Sistema</span>
                              <Form.Control 
                                type="text" 
                                value={userData[0].id} 
                                readOnly 
                                className="input-modern" 
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={12} md={8}>
                            <Form.Group className="mb-3">
                              <span className="label-modern">No. Empleado</span>
                              <Form.Control 
                                type="text" 
                                value={userData[0].numEmpleado} 
                                readOnly 
                                className="input-modern" 
                                style={{ color: '#4a90e2', fontWeight: 'bold' }}
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        <Form.Group className="mb-3">
                          <span className="label-modern">Nombre Completo</span>
                          <Form.Control 
                            type="text" 
                            value={userData[0].nombreEmpleado} 
                            readOnly 
                            className="input-modern" 
                            style={{ fontSize: '1.1rem' }}
                          />
                        </Form.Group>

                        <Form.Group className="mb-4">
                          <span className="label-modern">Departamento</span>
                          <Form.Control 
                            type="text" 
                            value={userData[0].departamento} 
                            readOnly 
                            className="input-modern" 
                          />
                        </Form.Group>

                        <Button onClick={saveFiles} className="btn-save">
                          Guardar Cambios
                        </Button>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <div className="text-center py-5 text-muted">
                    <h4>Cargando datos...</h4>
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}